require('angular').module('wowApp.common')
    .service('SuggestedListService', ['Restangular', '$q', 'BootstrapService', require('./suggestedlist.service')]);



// WEBPACK FOOTER //
// ./src/common/suggestedlist/index.js